export class HomeModel {
    public scempid: any;
    public commissionplan: string;
    public commyear: number;
    public calyear: any;
    public commission: any;
    public commissionval: any;
    public revenue: any;
    public revenueval: any;
    public calmon: any;
    public employeeid: string;
    public comm_plan_id: number;
    public calendar_type: string;
    public sales_channel: string;
    public edate: any;
    public comm_img_str: string;
    public effective_date: Date;
    public valid_from_dt: Date;
    public valid_to_dt: Date;
    public pay_dt: string;
    public user_role: string;
    public dispute_close_dt: Date;
    public calc_close_flag: string;

    public curDate: string;
    public prevDateOne: string;
    public prevDateTwo: string;

    constructor() {
        this.curDate = null;
        this.prevDateOne = null;
        this.prevDateTwo = null;

        this.calc_close_flag = null;
        this.dispute_close_dt = null;
        this.user_role = null;
        this.valid_from_dt = null;
        this.valid_to_dt = null;
        this.pay_dt = null;
        this.effective_date = null;
        this.comm_img_str = null;
        this.scempid = null;
        this.commissionplan = "";
        this.commyear = 0;
        this.calyear = "";
        this.commission = "";
        this.commissionval = "";
        this.revenue = "";
        this.revenueval = "";
        this.calmon = "";
        this.employeeid = "";
        this.comm_plan_id = 0;
        this.calendar_type = "";
        this.sales_channel = "";
        this.edate = "";
    }
}